import { FC } from 'react';

type Props = {
  data: {
    imageLink: string;
    imageSrc: string;
    location: string;
    text: string;
    textLink: string;
  };
};

const UserListItem: FC<Props> = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <li>
      <figure>
        <a href={data.imageLink}>
          <img alt="" src={data.imageSrc} />
        </a>
      </figure>
      <div className="caption">
        <h2>
          <a className="link xlate-none" href={data.textLink} title={data.text}>
            {data.text}
          </a>
        </h2>
        <span className="city">{data.location}</span>
      </div>
    </li>
  );
};

export default UserListItem;
